import { render, staticRenderFns } from "./RecordCostUnitSummary.vue?vue&type=template&id=f5993704"
import script from "./RecordCostUnitSummary.vue?vue&type=script&lang=js"
export * from "./RecordCostUnitSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports